export default {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundColor: '#FFFFFF',
        borderRadius: '8px'
      },
      elevation1: {
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)'
      }
    }
  }
};
